export default function useTitle(title) {
    document.title = `${title} | Водоканал - личный кабинет сотрудника`;
}